import { AbstractGenerateWorkplaceEntitiesStep } from './abstract-generate-workplace-entities-step';

export class GenerateWorkplaceWorkEquipmentsStep extends AbstractGenerateWorkplaceEntitiesStep {

}
